import React, { useEffect, useState } from "react";
import { getHiringStaff } from "../services/gurukulService"; // Import service
import "../styles/HiringPage.css"; // Import CSS
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const HiringPage = () => {
  const [hiringStaff, setHiringStaff] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedCandidate, setSelectedCandidate] = useState(null); // For modal or expandable view

  useEffect(() => {
    getHiringStaff()
      .then((response) => {
        setHiringStaff(response);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching hiring staff:", error);
        setError("Failed to load hiring staff data");
        setLoading(false);
      });
  }, []);

  // Function to handle "View More" button click
  const handleViewMore = (candidate) => {
    setSelectedCandidate(candidate);
  };

  // Function to close the modal or expandable view
  const handleClose = () => {
    setSelectedCandidate(null);
  };

   // Function to export HiringStaff to Excel
const downloadExcel = () => {
  if (hiringStaff.length === 0) {
    alert("No data available to export!");
    return;
  }

  const worksheet = XLSX.utils.json_to_sheet(hiringStaff); // Convert JSON to worksheet
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "HiringStaff");

  // Generate Excel file and trigger download
  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const data = new Blob([excelBuffer], { type: "application/octet-stream" });
  saveAs(data, "HiringStaff_list.xlsx");
};


  return (
    <div className="hiring-container">

    {/* Button to Download Excel */}
    <button className="download-excel-button" onClick={downloadExcel}>
        📥 Download Excel
      </button>

      <h2 className="hiring-heading">📌 Hiring Staff List</h2>

      {loading ? (
        <p className="loading-message">Loading hiring staff data...</p>
      ) : error ? (
        <p className="error-message">{error}</p>
      ) : (
        <table className="hiring-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Father's Name</th>
              <th>Subject</th>
              <th>Contact</th>
              <th>Email</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {hiringStaff.map((item, index) => (
              <tr key={item.id}>
                <td>{index + 1}</td>
                <td>{item.name}</td>
                <td>{item.fatherName}</td>
                <td>{item.subject}</td>
                <td>{item.contact}</td>
                <td>{item.email}</td>
                <td>
                  <button
                    className="view-more-button"
                    onClick={() => handleViewMore(item)}
                  >
                    View More
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {/* Modal or Expandable Section for Additional Details */}
      {selectedCandidate && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>Candidate Details</h3>
            <p><strong>Name:</strong> {selectedCandidate.name}</p>
            <p><strong>Father's Name:</strong> {selectedCandidate.fatherName}</p>
            <p><strong>DOB:</strong> {selectedCandidate.dob}</p>
            <p><strong>Village:</strong> {selectedCandidate.village}</p>
            <p><strong>Tehsil:</strong> {selectedCandidate.tehsil}</p>
            <p><strong>District:</strong> {selectedCandidate.district}</p>
            <p><strong>Pin Code:</strong> {selectedCandidate.pinCode}</p>
            <p><strong>Secondary Year:</strong> {selectedCandidate.secondaryYear}</p>
            <p><strong>Secondary Marks:</strong> {selectedCandidate.secondaryMarks}</p>
            <p><strong>Graduation Year:</strong> {selectedCandidate.graduationYear}</p>
            <p><strong>Graduation Marks:</strong> {selectedCandidate.graduationMarks}</p>
            <p><strong>University Name:</strong> {selectedCandidate.universityName}</p>
            <p><strong>Diploma Year:</strong> {selectedCandidate.diplomaYear}</p>
            <p><strong>Diploma Marks:</strong> {selectedCandidate.diplomaMarks}</p>
            <p><strong>Other Qualifications:</strong> {selectedCandidate.otherQualifications}</p>
            <p><strong>Agreement:</strong> {selectedCandidate.agreement ? "Yes" : "No"}</p>
            <button className="close-button" onClick={handleClose}>
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default HiringPage;